<!-- eslint-disable vue/no-confusing-v-for-v-if -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <modal v-if="isModalVisible !== false"
           :close-on-click-outside="true"
           :hide-buttons="true"
           :key="$t('modalUserSettings.title')"
           @cancel="isModalVisible = false">
      <hm-card-inner :full-size="true">
        <hm-col cols="12">
          <span class="info-text info-text--full-size info-text--no-margin col-12" v-html="$t('modalUserSettings.infoTextDeviceAndUserOnly')"></span>
        </hm-col>
      </hm-card-inner>
      <hm-card-inner :title="$t('modalUserSettings.card.displayOptions')">
        <hm-input-range :min="9"
                        :max="11"
                        :step="0.5"
                        :value-map="{ 9: 'XS', 9.5: 'S', 10: 'M', 10.5: 'L', 11: 'XL' }"
                        v-model="fontSize"
                        :label="$t('modalUserSettings.fontSize')"
                        fa-icon="fal fa-text-height"
                        name="fontSize" />
        <hm-input-toggle v-model="condensedTables"
                         :label="$t('modalUserSettings.condensedTables')"
                         name="condensedTables" />
        <hm-input-toggle v-model="highContrast"
                         :label="$t('modalUserSettings.highContrast')"
                         name="highContrast" />
      </hm-card-inner>
      <hm-card-inner :title="$t('modalUserSettings.card.deviceOptions')">
        <template v-if="hasLicense('InterfaceStripe') && hasLicense('StripeTerminal') && hotelSettings.interfaces.stripe.enabled && hotelSettings.interfaces.stripe.terminalEnabled && !isEmpty(hotelSettings.interfaces.stripe.terminals)">
          <hm-input-select v-model="stripeTerminalId"
                           :no-select="false"
                           :label="$t('modalUserSettings.stripeTerminalId')">
            <option :value="null">{{ $t('modalUserSettings.stripeTerminalNoSelect') }}</option>
            <option v-for="it in hotelSettings.interfaces.stripe.terminals" :key="it.first" :value="it.first">{{ it.second }} ({{ it.first }})</option>
          </hm-input-select>
        </template>
      </hm-card-inner>
    </modal>
  </div>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { isNil, isEmpty, sortBy } from 'lodash';
import HmInputSelect from '../inputs/HmInputSelect.vue';

export default {
  name: 'ModalUserSettings',
  components: { HmInputSelect },

  mixins: [HotelmeisterMixin],

  data() {
    return {
      isModalVisible: false,
      fontSize: null,
      condensedTables: null,
      highContrast: null,
      stripeTerminalId: null,
    };
  },

  computed: {
  },

  watch: {
    fontSize: function (newVal) {
      this.$serviceBus.$emit('update:fontSize', newVal);
    },
    highContrast: function (newVal) {
      this.$serviceBus.$emit('update:highContrast', newVal);
    },
    condensedTables: function (newVal) {
      this.setUserConfig('condensedTables', newVal || false, true);
      this.$serviceBus.$emit('update:condensedTables', newVal);
    },
    stripeTerminalId: function (newVal) {
      this.setUserConfig('stripeTerminalId', newVal || null, true);
    },
  },

  created: function () {
    this.fontSize = this.getUserConfig('fontSize', true) || 10;
    this.condensedTables = JSON.parse(this.getUserConfig('condensedTables', true)) || false;
    this.highContrast = JSON.parse(this.getUserConfig('highContrast', true)) || false;
    this.stripeTerminalId = this.getUserConfig('stripeTerminalId', true) || null;

    this.$serviceBus.$on('username.click', () => { this.isModalVisible = true; });
  },

  beforeDestroy() {
    this.$serviceBus.$off('username.click');
  },

  methods: {
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';


  .button-row {
    display: grid;
    justify-content: left;
    @media (min-width: $br-tablet){
      justify-content: end;
    }
    grid-template-columns: repeat(7, auto);
    grid-column-gap: 1.5rem;

    @media (min-width: $br-desktop){
      grid-template-columns: repeat(9, auto);
    }
  }
</style>

<style lang="scss">
  @import '~styles/import';

</style>



// WEBPACK FOOTER //
// src/components/lib/util/ModalUserSettings.vue